<div class="pageheader">
    <div class="page-title">
        <h1>Partner systems</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Partner_Action_SystemsShowLog'" [title]="'Partner systems log'">
                <app-change-log-link-entity type="PartnerSystem"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='partnerSystems' [bizSetColumnChooser]="false"
    [bizSetAllowColumnReordering]="false" [bizSetGroupPanel]="false" (onInitNewRow)="onInitNewRow($event)"
    (onRowInserted)="onRowInsertedOrUpdated($event)" (onRowUpdated)="onRowInsertedOrUpdated($event)"
    (onRowRemoving)="onRowRemoving($event)"
    [bizEditRowOnDoubleClick]="true">

    <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
        [allowDeleting]="allowDeleting">
        <dxo-popup title="Partner system" [showTitle]="true"></dxo-popup>
    </dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="Key" caption="Key" dataType="string">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column type="buttons">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log"
                    template="logTemplate"
                    [visible]="allowShowLog">
        </dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Partner_Action_SystemsShowLog'" [title]="'Logs for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="PartnerSystem" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>
</dx-data-grid>
